import { render, staticRenderFns } from "./emoji_picker.vue?vue&type=template&id=5056a9f9&scoped=true&"
import script from "./emoji_picker.vue?vue&type=script&lang=js&"
export * from "./emoji_picker.vue?vue&type=script&lang=js&"
import style0 from "./emoji_picker.vue?vue&type=style&index=0&id=5056a9f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5056a9f9",
  null
  
)

export default component.exports